import React, { Component, Fragment } from "react";
import Breadcrumb from "../../../common/breadcrumb";
import "react-toastify/dist/ReactToastify.css";
import { Tabs, TabList, TabPanel, Tab } from "react-tabs";
import { ToastContainer, toast } from "react-toastify";
import CountUp from "react-countup";
import { connect } from "react-redux";
import {
  getAllSourcingsRedux,
  uploadSourcingRedux,
  updateSourcingRedux,
  deleteSourcingRedux,
  getAllEmployeeRedux,
  updateEmployeeRedux,
  handleSourcingCashInRedux,
  handleSourcingCashOutRedux,
  uploadSourcingTransactionRedux,
  uploadExpenseRedux,
} from "../../../../actions";
import "./monthly-invoice.css";
import firebase from "firebase/app";
import {
  uploadImageD2dExpressProduct,
  uploadImage,
  updateImage,
  deleteImage,
} from "../../../../firebase/firebase.utils";
import { sendNotifications } from "../../../../firebase/fcmRestApi";
import man from "../../plus image.jpeg";

const emptyProductRow = () => ({
  id: `${Date.now()}${Math.floor(Math.random() * 1000)}`,
  imageUrl: "",
  productName: "",
  priceRmb: "",
  quantity: "",
});

const sourcingStatusGradients = {
  Purchasing: "linear-gradient(135deg, #fbbf24, #f59e0b)",
  Purchased: "linear-gradient(135deg, #fb923c, #ea580c)",
  "Abroad Warehouse": "linear-gradient(135deg, #60a5fa, #2563eb)",
  "In Shipment": "linear-gradient(135deg, #a78bfa, #7c3aed)",
  "Bangladesh Warehouse": "linear-gradient(135deg, #2dd4bf, #0d9488)",
  Delivered: "linear-gradient(135deg, #4ade80, #16a34a)",
  sourcing: "linear-gradient(135deg, #fbbf24, #f59e0b)",
};

const getSourcingStatusGradient = (status) =>
  sourcingStatusGradients[status] ||
  "linear-gradient(135deg, #9ca3af, #6b7280)";

const sumRefundArray = (arr) =>
  (arr || []).reduce((sum, r) => sum + (parseFloat(r.amount) || 0), 0);

// Refund given (Tk) and refund taken (RMB, converted to Tk via the
// invoice's buy rate) for a single invoice — used for the red/orange
// refund chips in the invoice detail row.
const getRefundTotals = (sourcing) => ({
  given: sumRefundArray(sourcing.givenRefund),
  taken: sumRefundArray(sourcing.receivedRefund) * (parseFloat(sourcing.buyRate) || 0),
});

export class MonthlyInvoices extends Component {
  constructor(props) {
    super(props);
    this.state = {
      totalBill: "",
      agent: "",
      totalRmb: "",
      sellRate: "",
      buyRate: "",
      shipping: "",
      productLink: "",
      productName: "",
      productsArray: [],
      totalPaid: 0,
      sourcingObj: null,
      type: "",
      buyingCost: 0,
      finalProfit: 0,
      customer: "",
      customerUid: "",
      cursor: -1,
      sourcingStatus: "",
      productDetails: "",
      country: "",
      filterCountry: "",
      trackingNo: "",
      shippingInformation: null,
      tkRefund: 0,
      tkRefundNote: "",
      rmbRefund: 0,
      rmbRefundNote: "",
      refundType: "",
      cashOutType: "Invoice Payment",
      otherCharge: 0,
      otherChargeNote: "",
      agentPaid: 0,
      finalProfit: 0,
      algProfit: 0,
      imageUrl: man,
      image_loader: false,
    };
  }

  componentDidMount = async () => {
    this.props.getAllSourcingsRedux(this.props.match.params.month);
    this.props.getAllEmployeeRedux();
  };

  addProductRow = () => {
    this.setState({
      productsArray: [...this.state.productsArray, emptyProductRow()],
    });
  };

  updateProductRow = (id, field, value) => {
    this.setState({
      productsArray: this.state.productsArray.map((product) =>
        product.id === id ? { ...product, [field]: value } : product,
      ),
    });
  };

  removeProductRow = (id) => {
    const removed = this.state.productsArray.find(
      (product) => product.id === id,
    );
    if (removed && removed.imageUrl) {
      deleteImage(removed.imageUrl);
    }
    this.setState({
      productsArray: this.state.productsArray.filter(
        (product) => product.id !== id,
      ),
    });
  };

  handleProductImageChange = async (id, file) => {
    if (!file) return;
    const existing = this.state.productsArray.find(
      (product) => product.id === id,
    );
    const imgUrl =
      existing && existing.imageUrl
        ? await updateImage(file, existing.imageUrl, "zapaiProducts")
        : await uploadImage(file, "zapaiProducts");
    if (imgUrl) {
      this.updateProductRow(id, "imageUrl", imgUrl);
    }
  };

  getProductsGrandTotal = () =>
    this.state.productsArray.reduce(
      (sum, product) =>
        sum +
        (parseFloat(product.priceRmb) || 0) *
          (parseFloat(product.quantity) || 0),
      0,
    );


  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };


  getMonthName = () => {
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const d = new Date();
    return `${monthNames[d.getMonth()]},${d.getFullYear()}`;
  };

  _handleImgChange = async (e, i) => {
    e.preventDefault();
    if (this.props.currentUser.displayName === "") {
      alert("Please log in to your account to request a booking");
      document.getElementById("modal-close-icon-door-to-door").click();
      return;
    }

    let reader = new FileReader();
    let file = e.target.files[0];
    const { imageUrl } = this.state;

    reader.onloadend = () => {
      this.setState({
        file: file,
        imageUrl,
      });
    };
    if (file) {
      this.setState({ image_loader: true });
      reader.readAsDataURL(file);
      const imgUrl = await uploadImageD2dExpressProduct(file);
      console.log(imgUrl);

      this.setState({
        imageUrl: imgUrl,
      });
      console.log(imageUrl);
      this.setState({ image_loader: false });
    }
  };
  handleSubmit = async (sourcing) => {
    let date = new Date();
    if (this.state.customer === "") {
      alert("Please enter a customer name first");
      return;
    }
    const productsArray = this.state.productsArray.map((product) => ({
      ...product,
      totalRmb: (
        (parseFloat(product.priceRmb) || 0) *
        (parseFloat(product.quantity) || 0)
      ).toFixed(2),
    }));
    const packingListProductName =
      productsArray.length > 0 ? productsArray[0].productName : "";
    if (this.state.type === "upload") {
      await this.props.uploadSourcingRedux({
        ...this.state,
        id: date.getTime().toString(),
        month: this.getMonthName(),
        date: date.toLocaleDateString("en-GB"),
        localWarehouseDateTimeStamp: firebase.firestore.Timestamp.now(),
        status: "pending",
        totalBill: parseInt(
          parseFloat(this.state.sellRate || 0) *
            parseFloat(this.state.totalRmb || 0) +
            parseInt(this.state.shipping || 0),
        ),
        category: "sourcing",
        invoiceStatus: "Not Paid",
        sourcingStatus: "Pending",
        productsArray,
        productName: packingListProductName,
      });

      const message = {
        title: `Order Invoice`,
        body: `A new Order invoice has been added to your account.Please check the information.`,
      };
      const userObj = this.props.allUsers.find(
        (user) => user.uid == this.state.customerUid,
      );
      console.log(userObj);
      if (userObj && userObj.deviceToken && userObj.deviceToken.length > 0) {
        userObj.deviceToken.map((token) => {
          sendNotifications(token, message);
        });
      }
    } else if (this.state.type === "update") {
      let sourcingObj = {
        ...this.state,
        id: sourcing.id,
        month: sourcing.month,
        date: sourcing.date,
        status: "pending",
        sourcingObj: null,
        totalBill: parseInt(
          parseFloat(this.state.sellRate || 0) *
            parseFloat(this.state.totalRmb || 0) +
            parseInt(this.state.shipping || 0),
        ),
        productsArray,
        productName: packingListProductName,
      };
      await this.props.updateSourcingRedux(sourcingObj);
    }

    this.setState({
      totalBill: "",
      agent: "",
      totalRmb: "",
      sellRate: "",
      buyRate: "",
      productLink: "",
      productName: "",
      productsArray: [],
      shipping: "",
      totalPaid: 0,
      sourcingObj: null,
      type: "",
      buyingCost: 0,
      finalProfit: 0,
      customer: "",
      customerUid: "",
      cursor: -1,
      country: "",
      agentPaid: 0,
      finalProfit: 0,
      algProfit: 0,
    });
  };

  handleCashIn = async () => {
    const { currentAdmin } = this.props;
    let date = new Date();
    if (!this.state.totalPaid || this.state.totalPaid == 0) {
      alert("Please enter an amount first");
      return;
    }
    let remainingBalance2 = parseFloat(this.state.sourcingObj.totalBill);
    if (this.state.sourcingObj) {
      remainingBalance2 = parseFloat(this.state.sourcingObj.totalBill);
      let receivedCash = 0;
      if (
        this.state.sourcingObj.cashIns &&
        this.state.sourcingObj.cashIns.length > 0
      ) {
        this.state.sourcingObj.cashIns.map((cashIn) => {
          receivedCash += parseInt(cashIn.amount);
        });
        remainingBalance2 =
          parseFloat(this.state.sourcingObj.totalBill) - receivedCash;
      }
    }

    if (this.state.totalPaid > parseInt(remainingBalance2)) {
      alert("Received amount must be less than orders remaining due.");
      return;
    }
    this.props.handleSourcingCashInRedux({
      ...this.state.sourcingObj,
      totalPaid: this.state.totalPaid,
      paymentId: date.getTime().toString(),
      month: this.getMonthName(),
      date: date.toLocaleDateString("en-GB"),
      receiveBy: currentAdmin.name,
      cashIns:
        this.state.sourcingObj.cashIns &&
        this.state.sourcingObj.cashIns.length > 0
          ? [
              {
                id: date.getTime().toString(),
                amount: this.state.totalPaid,
                date: date.toLocaleDateString("en-GB"),
                expenseBy: currentAdmin.name,
              },
              ...this.state.sourcingObj.cashIns,
            ]
          : [
              {
                id: date.getTime().toString(),
                amount: this.state.totalPaid,
                date: date.toLocaleDateString("en-GB"),
                expenseBy: currentAdmin.name,
              },
            ],
    });
    this.setState({
      totalPaid: 0,
    });
  };

  handleStatusChange = async () => {
    const { currentAdmin } = this.props;
    let date = new Date();
    if (!this.state.sourcingStatus) {
      alert("Please select a status first");
      return;
    }
    let sourcingDate;
    let purchasedDate;
    let abroadWarehouseDate;
    let InShipmentDate;
    let bangladeshWarehouseDate;
    let deliveredDate;
    if (this.state.sourcingStatus === "Purchasing") {
      sourcingDate = date.toLocaleDateString("en-GB");
      this.props.updateSourcingRedux({
        ...this.state.sourcingObj,
        sourcingDate,
        sourcingStatus: this.state.sourcingStatus,
        trackingNo: this.state.trackingNo,
        tkRefund: this.state.sourcingObj.tkRefund
          ? parseInt(this.state.sourcingObj.tkRefund) +
            parseInt(this.state.tkRefund)
          : parseInt(this.state.tkRefund),
        tkRefundNote: this.state.tkRefundNote,
        rmbRefund: this.state.rmbRefund,
        rmbRefundNote: this.state.rmbRefundNote,
      });
    }
    if (this.state.sourcingStatus == "Purchased") {
      purchasedDate = date.toLocaleDateString("en-GB");
      this.props.updateSourcingRedux({
        ...this.state.sourcingObj,
        sourcingDate: this.state.sourcingObj.sourcingDate
          ? this.state.sourcingObj.sourcingDate
          : date.toLocaleDateString("en-GB"),
        purchasedDate,
        sourcingStatus: this.state.sourcingStatus,
        trackingNo: this.state.trackingNo,
        tkRefund: this.state.tkRefund,
        tkRefundNote: this.state.tkRefundNote,
        rmbRefund: this.state.rmbRefund,
        rmbRefundNote: this.state.rmbRefundNote,
      });
    }
    if (this.state.sourcingStatus == "Abroad Warehouse") {
      abroadWarehouseDate = date.toLocaleDateString("en-GB");
      this.props.updateSourcingRedux({
        ...this.state.sourcingObj,
        sourcingDate: this.state.sourcingObj.sourcingDate
          ? this.state.sourcingObj.sourcingDate
          : date.toLocaleDateString("en-GB"),
        purchasedDate: this.state.sourcingObj.purchasedDate
          ? this.state.sourcingObj.purchasedDate
          : date.toLocaleDateString("en-GB"),
        abroadWarehouseDate,
        sourcingStatus: this.state.sourcingStatus,
        trackingNo: this.state.trackingNo,
        tkRefund: this.state.tkRefund,
        tkRefundNote: this.state.tkRefundNote,
        rmbRefund: this.state.rmbRefund,
        rmbRefundNote: this.state.rmbRefundNote,
      });
    }
    if (this.state.sourcingStatus == "In Shipment") {
      InShipmentDate = date.toLocaleDateString("en-GB");
      this.props.updateSourcingRedux({
        ...this.state.sourcingObj,
        sourcingDate: this.state.sourcingObj.sourcingDate
          ? this.state.sourcingObj.sourcingDate
          : date.toLocaleDateString("en-GB"),
        purchasedDate: this.state.sourcingObj.purchasedDate
          ? this.state.sourcingObj.purchasedDate
          : date.toLocaleDateString("en-GB"),
        abroadWarehouseDate: this.state.sourcingObj.abroadWarehouseDate
          ? this.state.sourcingObj.abroadWarehouseDate
          : date.toLocaleDateString("en-GB"),
        InShipmentDate,
        sourcingStatus: this.state.sourcingStatus,
        trackingNo: this.state.trackingNo,
      });
    }
    if (this.state.sourcingStatus == "Bangladesh Warehouse") {
      bangladeshWarehouseDate = date.toLocaleDateString("en-GB");
      this.props.updateSourcingRedux({
        ...this.state.sourcingObj,
        sourcingDate: this.state.sourcingObj.sourcingDate
          ? this.state.sourcingObj.sourcingDate
          : date.toLocaleDateString("en-GB"),
        purchasedDate: this.state.sourcingObj.purchasedDate
          ? this.state.sourcingObj.purchasedDate
          : date.toLocaleDateString("en-GB"),
        abroadWarehouseDate: this.state.sourcingObj.abroadWarehouseDate
          ? this.state.sourcingObj.abroadWarehouseDate
          : date.toLocaleDateString("en-GB"),
        InShipmentDate: this.state.sourcingObj.InShipmentDate
          ? this.state.sourcingObj.InShipmentDate
          : date.toLocaleDateString("en-GB"),
        bangladeshWarehouseDate,
        sourcingStatus: this.state.sourcingStatus,
        trackingNo: this.state.trackingNo,
      });
    }
    if (this.state.sourcingStatus == "Delivered") {
      deliveredDate = date.toLocaleDateString("en-GB");
      this.props.updateSourcingRedux({
        ...this.state.sourcingObj,
        sourcingDate: this.state.sourcingObj.sourcingDate
          ? this.state.sourcingObj.sourcingDate
          : date.toLocaleDateString("en-GB"),
        purchasedDate: this.state.sourcingObj.purchasedDate
          ? this.state.sourcingObj.purchasedDate
          : date.toLocaleDateString("en-GB"),
        abroadWarehouseDate: this.state.sourcingObj.abroadWarehouseDate
          ? this.state.sourcingObj.abroadWarehouseDate
          : date.toLocaleDateString("en-GB"),
        InShipmentDate: this.state.sourcingObj.InShipmentDate
          ? this.state.sourcingObj.InShipmentDate
          : date.toLocaleDateString("en-GB"),
        bangladeshWarehouseDate: this.state.sourcingObj.bangladeshWarehouseDate
          ? this.state.sourcingObj.bangladeshWarehouseDate
          : date.toLocaleDateString("en-GB"),
        deliveredDate,
        sourcingStatus: this.state.sourcingStatus,
        trackingNo: this.state.trackingNo,
      });
    }
    if (this.state.trackingNo) {
      const message = {
        title: `Order Tracking no added.`,
        body: `Now you can track your order request Id:${this.state.sourcingObj.id} with tracking no:${this.state.trackingNo}.`,
      };
      const userObj = this.props.allUsers.find(
        (user) => user.uid == this.state.sourcingObj.customerUid,
      );
      console.log(userObj);
      if (userObj && userObj.deviceToken && userObj.deviceToken.length > 0) {
        userObj.deviceToken.map((token) => {
          sendNotifications(token, message);
        });
      }
    }
    this.setState({
      totalPaid: 0,
      sourcingStatus: "",
    });
  };
  handleRefund = async (totalRefundGiven) => {
    const { currentAdmin, allEmployees } = this.props;
    const { sourcingObj } = this.state;
    let date = new Date();
    if (!this.state.refundType) {
      alert("Please a refund type first.");
      return;
    }
    console.log(
      this.state.refundType,
      this.state.rmbRefund,
      this.state.rmbRefundNote,
    );
    let selectedEmployee = allEmployees.find(
      (employee) => employee.adminId == currentAdmin.adminId,
    );
    if (
      this.state.refundType == "RECEIVED" &&
      this.state.rmbRefund != 0 &&
      this.state.rmbRefundNote &&
      selectedEmployee
    ) {
      // Refund taken from the supplier is in RMB — convert to Tk using the
      // invoice's buy rate and add it back to both profit figures.
      const refundTakenTk =
        parseFloat(this.state.rmbRefund) *
        parseFloat(sourcingObj.buyRate || 0);
      this.props.updateSourcingRedux({
        ...sourcingObj,
        status: "approved",
        finalProfit: (parseFloat(sourcingObj.finalProfit) || 0) + refundTakenTk,
        algProfit: (parseFloat(sourcingObj.algProfit) || 0) + refundTakenTk,
        receivedRefund:
          sourcingObj.receivedRefund && sourcingObj.receivedRefund.length > 0
            ? [
                ...sourcingObj.receivedRefund,
                {
                  id: date.getTime().toString(),
                  amount: this.state.rmbRefund,
                  date: date.toLocaleDateString("en-GB"),
                  note: this.state.rmbRefundNote,
                  expenseBy: currentAdmin.name,
                },
              ]
            : [
                {
                  id: date.getTime().toString(),
                  amount: this.state.rmbRefund,
                  date: date.toLocaleDateString("en-GB"),
                  note: this.state.rmbRefundNote,
                  expenseBy: currentAdmin.name,
                },
              ],
      });
      if (this.state.sourcingObj.country == "CHINA") {
        let rmbBalance =
          parseFloat(selectedEmployee.rmbBalance) +
          parseFloat(this.state.rmbRefund);
        let rupeeBalance = parseFloat(selectedEmployee.rupeeBalance);
        this.props.updateEmployeeRedux({
          ...selectedEmployee,
          rmbBalance,
          rupeeBalance,
        });
        this.props.uploadSourcingTransactionRedux({
          id: date.getTime().toString(),
          fundType: `RMB`,
          subCategory: `Sourcing Refund Received, Invoice: ${this.state.sourcingObj.id}, Date ${this.state.sourcingObj.date}`,
          month: this.getMonthName(),
          date: date.toLocaleDateString("en-GB"),
          note: `Buy Rate = ${this.state.sourcingObj.buyRate}`,
          buyRate: this.state.sourcingObj.buyRate,
          amount: this.state.rmbRefund * this.state.sourcingObj.buyRate,
          totalRmb: this.state.rmbRefund,
          expenseBy: currentAdmin.name,
          uid: this.state.customerUid,
          unEditable: true,
          employeeId: selectedEmployee.employeeId,
          rmbBalance,
          rupeeBalance,
        });
      }
      if (this.state.sourcingObj.country == "INDIA") {
        let rupeeBalance =
          parseFloat(selectedEmployee.rupeeBalance) +
          parseFloat(this.state.rmbRefund);
        let rmbBalance = parseFloat(selectedEmployee.rmbBalance);
        this.props.updateEmployeeRedux({
          ...selectedEmployee,
          rmbBalance,
          rupeeBalance,
        });
        this.props.uploadSourcingTransactionRedux({
          id: date.getTime().toString(),
          fundType: `RUPEES`,
          subCategory: `Sourcing Refund Received, Invoice: ${this.state.sourcingObj.id}, Date ${this.state.sourcingObj.date}`,
          month: this.getMonthName(),
          date: date.toLocaleDateString("en-GB"),
          note: `Buy Rate = ${this.state.sourcingObj.buyRate}`,
          buyRate: this.state.sourcingObj.buyRate,
          amount: this.state.rmbRefund * this.state.sourcingObj.buyRate,
          totalRmb: this.state.rmbRefund,
          expenseBy: currentAdmin.name,
          uid: this.state.customerUid,
          unEditable: true,
          employeeId: selectedEmployee.employeeId,
          rmbBalance,
          rupeeBalance,
        });
      }
    } else if (
      this.state.refundType == "GIVEN" &&
      this.state.tkRefund != 0 &&
      this.state.tkRefundNote
    ) {
      if (
        parseInt(this.state.tkRefund) + parseInt(totalRefundGiven) >
        parseInt(sourcingObj.totalBill)
      ) {
        alert("Refund amount can't be more than total bill");
        return;
      }
      // Refund given to the customer is already in Tk — subtract it
      // straight from both profit figures.
      this.props.updateSourcingRedux({
        ...sourcingObj,
        status: "approved",
        finalProfit:
          (parseFloat(sourcingObj.finalProfit) || 0) -
          parseInt(this.state.tkRefund),
        algProfit:
          (parseFloat(sourcingObj.algProfit) || 0) -
          parseInt(this.state.tkRefund),
        givenRefund:
          sourcingObj.givenRefund && sourcingObj.givenRefund.length > 0
            ? [
                ...sourcingObj.givenRefund,
                {
                  id: date.getTime().toString(),
                  amount: this.state.tkRefund,
                  date: date.toLocaleDateString("en-GB"),
                  note: this.state.tkRefundNote,
                  expenseBy: currentAdmin.name,
                },
              ]
            : [
                {
                  id: date.getTime().toString(),
                  amount: this.state.tkRefund,
                  date: date.toLocaleDateString("en-GB"),
                  note: this.state.tkRefundNote,
                  expenseBy: currentAdmin.name,
                },
              ],
      });

      this.props.uploadExpenseRedux({
        amount: parseInt(this.state.tkRefund),
        category: "sourcing",
        subCategory: `Agent - ${sourcingObj.agent}`,
        note: `Refund given, Invoice:${sourcingObj.id}
          Date: ${sourcingObj.date}, Total Bill:${sourcingObj.totalBill}Tk`,
        date: date.toLocaleDateString("en-GB"),
        id: date.getTime().toString(),
        month: this.getMonthName(),
        receiveBy: currentAdmin.name,
        status: "pending",
        unEditable: true,
      });
    } else {
      alert("Please fill all missing information.");
      return;
    }

    this.setState({
      refundType: "",
      rmbRefund: 0,
      rmbRefundNote: "",
      tkRefund: 0,
      tkRefundNote: "",
    });
  };

  handleCashOut = async () => {
    const { currentAdmin, allEmployees } = this.props;
    let selectedEmployee = allEmployees.find(
      (employee) => employee.adminId == currentAdmin.adminId,
    );
    let date = new Date();
    let remainingBalance = parseFloat(this.state.sourcingObj.totalRmb);
    if (this.state.sourcingObj) {
      remainingBalance = parseFloat(this.state.sourcingObj.totalRmb);
      let spentCash = 0;
      if (
        this.state.sourcingObj.cashOuts &&
        this.state.sourcingObj.cashOuts.length > 0
      ) {
        this.state.sourcingObj.cashOuts.map((cashOut) => {
          spentCash += parseInt(cashOut.rmb);
        });
        remainingBalance =
          parseFloat(this.state.sourcingObj.totalRmb) - spentCash;
      }
    }
    if (!selectedEmployee) {
      alert("Sorry you are not assigned to spend.");
      return;
    }
    if (!this.state.buyingCost || this.state.buyingCost == 0) {
      alert("Please enter an amount first");
      return;
    }
    console.log(remainingBalance);
    console.log(this.state.buyingCost);
    if (parseFloat(this.state.buyingCost) > parseFloat(remainingBalance)) {
      alert("Your spend amount must be less than your remaining payment.");
      return;
    }

    // for india
    if (this.state.sourcingObj.country == "INDIA") {
      if (
        parseFloat(selectedEmployee.rupeeBalance) >=
        parseFloat(this.state.buyingCost)
      ) {
        let rupeeBalance =
          parseFloat(selectedEmployee.rupeeBalance) -
          parseFloat(this.state.buyingCost);
        let rmbBalance = parseFloat(selectedEmployee.rmbBalance);
        this.props.handleSourcingCashOutRedux({
          ...this.state.sourcingObj,
          buyingCost: this.state.sourcingObj.buyingCost
            ? parseInt(this.state.sourcingObj.buyingCost) +
              parseInt(this.state.buyingCost * this.state.sourcingObj.buyRate)
            : parseInt(this.state.buyingCost * this.state.sourcingObj.buyRate),
          finalProfit:
            this.state.sourcingObj.totalPaid -
            (this.state.sourcingObj.buyingCost
              ? parseInt(this.state.sourcingObj.buyingCost) +
                parseInt(this.state.buyingCost * this.state.sourcingObj.buyRate)
              : parseInt(
                  this.state.buyingCost * this.state.sourcingObj.buyRate,
                )),
          agentPaid: this.state.sourcingObj.agentPaid
            ? this.state.sourcingObj.agentPaid
            : 0,
          algProfit:
            this.state.sourcingObj.totalPaid -
              (this.state.sourcingObj.buyingCost
                ? parseInt(this.state.sourcingObj.buyingCost) +
                  parseInt(
                    this.state.buyingCost * this.state.sourcingObj.buyRate,
                  )
                : parseInt(
                    this.state.buyingCost * this.state.sourcingObj.buyRate,
                  )) -
              this.state.sourcingObj.agentPaid || 0,
          paymentId: date.getTime().toString(),
          // buyingcost2 is important for transactions
          buyingcost2: parseFloat(this.state.buyingCost).toFixed(2),
          employeeId: selectedEmployee.employeeId,
          month: this.getMonthName(),
          date: date.toLocaleDateString("en-GB"),
          rmbBalance,
          fundType: "RUPEES",
          rupeeBalance,
          expenseBy: currentAdmin.name,
          cashOuts:
            this.state.sourcingObj.cashOuts &&
            this.state.sourcingObj.cashOuts.length > 0
              ? [
                  {
                    id: date.getTime().toString(),
                    amount: parseInt(
                      this.state.buyingCost * this.state.sourcingObj.buyRate,
                    ),
                    date: date.toLocaleDateString("en-GB"),
                    rmb: this.state.buyingCost,
                    expenseBy: currentAdmin.name,
                  },
                  ...this.state.sourcingObj.cashOuts,
                ]
              : [
                  {
                    id: date.getTime().toString(),
                    amount: parseInt(
                      this.state.buyingCost * this.state.sourcingObj.buyRate,
                    ),
                    date: date.toLocaleDateString("en-GB"),
                    rmb: this.state.buyingCost,
                    expenseBy: currentAdmin.name,
                  },
                ],
        });
        this.props.updateEmployeeRedux({
          ...selectedEmployee,
          rmbBalance,
          rupeeBalance,
        });
      } else {
        alert("You don't have sufficient balance for this payment.");
      }
    }
    // for china
    else if (this.state.sourcingObj.country == "CHINA") {
      if (
        parseFloat(selectedEmployee.rmbBalance) >=
        parseFloat(this.state.buyingCost)
      ) {
        let rmbBalance =
          parseFloat(selectedEmployee.rmbBalance) -
          parseFloat(this.state.buyingCost);
        let rupeeBalance = parseFloat(selectedEmployee.rupeeBalance);
        this.props.handleSourcingCashOutRedux({
          ...this.state.sourcingObj,
          buyingCost: this.state.sourcingObj.buyingCost
            ? parseInt(this.state.sourcingObj.buyingCost) +
              parseInt(this.state.buyingCost * this.state.sourcingObj.buyRate)
            : parseInt(this.state.buyingCost * this.state.sourcingObj.buyRate),
          finalProfit:
            this.state.sourcingObj.totalPaid -
            (this.state.sourcingObj.buyingCost
              ? parseInt(this.state.sourcingObj.buyingCost) +
                parseInt(this.state.buyingCost * this.state.sourcingObj.buyRate)
              : parseInt(
                  this.state.buyingCost * this.state.sourcingObj.buyRate,
                )),
          agentPaid: this.state.sourcingObj.agentPaid
            ? this.state.sourcingObj.agentPaid
            : 0,
          algProfit:
            this.state.sourcingObj.totalPaid -
              (this.state.sourcingObj.buyingCost
                ? parseInt(this.state.sourcingObj.buyingCost) +
                  parseInt(
                    this.state.buyingCost * this.state.sourcingObj.buyRate,
                  )
                : parseInt(
                    this.state.buyingCost * this.state.sourcingObj.buyRate,
                  )) -
              this.state.sourcingObj.agentPaid || 0,
          paymentId: date.getTime().toString(),
          // buyingcost2 is important for transactions
          buyingcost2: parseFloat(this.state.buyingCost).toFixed(2),
          employeeId: selectedEmployee.employeeId,
          month: this.getMonthName(),
          date: date.toLocaleDateString("en-GB"),
          fundType: "RMB",
          rmbBalance,
          rupeeBalance,
          expenseBy: currentAdmin.name,
          cashOuts:
            this.state.sourcingObj.cashOuts &&
            this.state.sourcingObj.cashOuts.length > 0
              ? [
                  {
                    id: date.getTime().toString(),
                    amount: parseInt(
                      this.state.buyingCost * this.state.sourcingObj.buyRate,
                    ),
                    date: date.toLocaleDateString("en-GB"),
                    rmb: this.state.buyingCost,
                    expenseBy: currentAdmin.name,
                  },
                  ...this.state.sourcingObj.cashOuts,
                ]
              : [
                  {
                    id: date.getTime().toString(),
                    amount: parseInt(
                      this.state.buyingCost * this.state.sourcingObj.buyRate,
                    ),
                    date: date.toLocaleDateString("en-GB"),
                    rmb: this.state.buyingCost,
                    expenseBy: currentAdmin.name,
                  },
                ],
        });
        this.props.updateEmployeeRedux({
          ...selectedEmployee,
          rmbBalance,
          rupeeBalance,
        });
      } else {
        alert("You don't have sufficient balance for this payment.");
      }
    } else {
      alert("No country is assigned with this order. ");
    }

    this.setState({
      buyingCost: 0,
      cashOutType: "Invoice Payment",
    });
  };
  handleCashOutOtherCharge = async () => {
    const { currentAdmin, allEmployees } = this.props;
    let selectedEmployee = allEmployees.find(
      (employee) => employee.adminId == currentAdmin.adminId,
    );
    let date = new Date();

    if (!selectedEmployee) {
      alert("Sorry you are not assigned to spend.");
      return;
    }
    if (!this.state.otherCharge || this.state.otherCharge == 0) {
      alert("Please enter an amount first");
      return;
    }
    if (!this.state.otherChargeNote) {
      alert("You must write a note about other charge.");
      return;
    }

    // for india
    if (this.state.sourcingObj.country == "INDIA") {
      if (
        parseFloat(selectedEmployee.rupeeBalance) >=
        parseFloat(this.state.otherCharge)
      ) {
        let rupeeBalance =
          parseFloat(selectedEmployee.rupeeBalance) -
          parseFloat(this.state.otherCharge);
        let rmbBalance = parseFloat(selectedEmployee.rmbBalance);
        this.props.handleSourcingCashOutRedux({
          ...this.state.sourcingObj,
          paymentId: date.getTime().toString(),
          // buyingcost2 is important for transactions
          buyingcost2: parseFloat(this.state.otherCharge).toFixed(2),
          employeeId: selectedEmployee.employeeId,
          month: this.getMonthName(),
          date: date.toLocaleDateString("en-GB"),
          rmbBalance,
          fundType: "RUPEES",
          rupeeBalance,
          expenseBy: currentAdmin.name,
          otherCharges:
            this.state.sourcingObj.otherCharges &&
            this.state.sourcingObj.otherCharges.length > 0
              ? [
                  {
                    id: date.getTime().toString(),
                    amount: parseInt(
                      this.state.otherCharge * this.state.sourcingObj.buyRate,
                    ),
                    date: date.toLocaleDateString("en-GB"),
                    rmb: this.state.otherCharge,
                    note: this.state.otherChargeNote,
                    expenseBy: currentAdmin.name,
                  },
                  ...this.state.sourcingObj.otherCharges,
                ]
              : [
                  {
                    id: date.getTime().toString(),
                    amount: parseInt(
                      this.state.otherCharge * this.state.sourcingObj.buyRate,
                    ),
                    date: date.toLocaleDateString("en-GB"),
                    rmb: this.state.otherCharge,
                    note: this.state.otherChargeNote,
                    expenseBy: currentAdmin.name,
                  },
                ],
        });
        this.props.updateEmployeeRedux({
          ...selectedEmployee,
          rmbBalance,
          rupeeBalance,
        });
      } else {
        alert("You don't have sufficient balance for this payment.");
      }
    }
    // for china
    else if (this.state.sourcingObj.country == "CHINA") {
      if (
        parseFloat(selectedEmployee.rmbBalance) >=
        parseFloat(this.state.otherCharge)
      ) {
        let rmbBalance =
          parseFloat(selectedEmployee.rmbBalance) -
          parseFloat(this.state.otherCharge);
        let rupeeBalance = parseFloat(selectedEmployee.rupeeBalance);
        this.props.handleSourcingCashOutRedux({
          ...this.state.sourcingObj,

          paymentId: date.getTime().toString(),
          // buyingcost2 is important for transactions
          buyingcost2: parseFloat(this.state.otherCharge).toFixed(2),
          employeeId: selectedEmployee.employeeId,
          month: this.getMonthName(),
          date: date.toLocaleDateString("en-GB"),
          fundType: "RMB",
          rmbBalance,
          rupeeBalance,
          expenseBy: currentAdmin.name,
          otherCharges:
            this.state.sourcingObj.otherCharges &&
            this.state.sourcingObj.otherCharges.length > 0
              ? [
                  {
                    id: date.getTime().toString(),
                    amount: parseInt(
                      this.state.otherCharge * this.state.sourcingObj.buyRate,
                    ),
                    date: date.toLocaleDateString("en-GB"),
                    rmb: this.state.otherCharge,
                    note: this.state.otherChargeNote,
                    expenseBy: currentAdmin.name,
                  },
                  ...this.state.sourcingObj.otherCharges,
                ]
              : [
                  {
                    id: date.getTime().toString(),
                    amount: parseInt(
                      this.state.otherCharge * this.state.sourcingObj.buyRate,
                    ),
                    date: date.toLocaleDateString("en-GB"),
                    rmb: this.state.otherCharge,
                    note: this.state.otherChargeNote,
                    expenseBy: currentAdmin.name,
                  },
                ],
        });
        this.props.updateEmployeeRedux({
          ...selectedEmployee,
          rmbBalance,
          rupeeBalance,
        });
      } else {
        alert("You don't have sufficient balance for this payment.");
      }
    } else {
      alert("No country is assigned with this order. ");
    }

    this.setState({
      otherCharge: 0,
      otherChargeNote: "",
      cashOutType: "Invoice Payment",
    });
  };

  render() {
    const { open, sourcingObj, shippingInformation } = this.state;
    const { sourcings, allEmployees, currentAdmin } = this.props;
    let selectedEmployee = null;
    if (allEmployees.length && currentAdmin) {
      selectedEmployee = allEmployees.find(
        (employee) => employee.adminId == currentAdmin.adminId,
      );
    }
    let remainingBalance = 0;
    if (this.state.sourcingObj) {
      remainingBalance = parseFloat(this.state.sourcingObj.totalRmb);

      let spentCash = 0;
      if (
        this.state.sourcingObj.cashOuts &&
        this.state.sourcingObj.cashOuts.length > 0
      ) {
        this.state.sourcingObj.cashOuts.map((cashOut) => {
          spentCash += parseFloat(cashOut.rmb);
        });
        console.log(spentCash);
        console.log(remainingBalance);
        remainingBalance =
          parseFloat(this.state.sourcingObj.totalRmb) - spentCash;
        console.log(remainingBalance);
      }
    }

    let remainingBalance2 = 0;
    if (this.state.sourcingObj) {
      remainingBalance2 = parseFloat(this.state.sourcingObj.totalBill);
      let receivedCash = 0;
      if (
        this.state.sourcingObj.cashIns &&
        this.state.sourcingObj.cashIns.length > 0
      ) {
        this.state.sourcingObj.cashIns.map((cashIn) => {
          receivedCash += parseInt(cashIn.amount);
        });
        remainingBalance2 =
          parseFloat(this.state.sourcingObj.totalBill) - receivedCash;
      }
    }

    let date = new Date();
    let totalBill = 0;
    let totalRmb = 0;
    let totalPaid = 0;
    let buyingCost = 0;
    let totalProfit = 0;
    let sellRate = 0;
    let buyRate = 0;
    let shipping = 0;
    let totalRefundGiven = 0;
    let totalRefundReceived = 0;
    let totalRefundReceivedTk = 0;
    let totalOtherCharges = 0;
    let totalOtherChargesTk = 0;
    if (
      sourcingObj &&
      sourcingObj.receivedRefund &&
      sourcingObj.receivedRefund.length > 0
    ) {
      sourcingObj.receivedRefund.map((refund) => {
        totalRefundReceived += parseFloat(refund.amount);
      });
      totalRefundReceivedTk = parseInt(
        totalRefundReceived * sourcingObj.buyRate,
      );
    }
    if (
      sourcingObj &&
      sourcingObj.otherCharges &&
      sourcingObj.otherCharges.length > 0
    ) {
      sourcingObj.otherCharges.map((refund) => {
        totalOtherCharges += parseFloat(refund.rmb);
      });
      totalOtherChargesTk = parseInt(totalOtherCharges * sourcingObj.buyRate);
    }
    if (
      sourcingObj &&
      sourcingObj.givenRefund &&
      sourcingObj.givenRefund.length > 0
    ) {
      sourcingObj.givenRefund.map((refund) => {
        totalRefundGiven += parseFloat(refund.amount);
      });
    }
    let renderablesourcings = [];
    if (!this.state.filterCountry) {
      renderablesourcings = sourcings.filter((sourcing) => sourcing.agent);
    } else {
      renderablesourcings = sourcings
        .filter((sourcing) => sourcing.agent)
        .filter((sourcing) => sourcing.country === this.state.filterCountry);
    }
    if (renderablesourcings.length > 0) {
      renderablesourcings.map((sourcing) => {
        totalBill += parseInt(sourcing.totalBill || 0);
        totalRmb += parseInt(sourcing.totalRmb || 0);
        totalPaid += parseInt(sourcing.totalPaid || 0);
        buyingCost += parseInt(sourcing.buyingCost || 0);
        totalProfit += parseInt(sourcing.finalProfit || 0);
        sellRate += parseFloat(sourcing.sellRate || 0);
        buyRate += parseFloat(sourcing.buyRate || 0);
        shipping += parseFloat(sourcing.shipping || 0);
      });
    }

    let total = 0;
    if (shippingInformation) {
      shippingInformation.parcelsArray.map(
        (parcel) => (total += parseInt(parcel.finalTotal)),
      );
    }
    let summaryRefundGiven = 0;
    let summaryRefundTaken = 0;
    if (renderablesourcings.length > 0) {
      renderablesourcings.map((sourcing) => {
        const refundTotals = getRefundTotals(sourcing);
        summaryRefundGiven += refundTotals.given;
        summaryRefundTaken += refundTotals.taken;
      });
    }
    return (
      <Fragment>
        <Breadcrumb title={"order"} parent="Wholesale Management" />
        {/* <!-- Container-fluid starts--> */}
        <div className="container-fluid">
          <div className="row" style={{ justifyContent: "center" }}>
            <div className="col-sm-12">
              <div className="consultancy-summary-card">
                <div className="consultancy-summary-header">
                  <span className="consultancy-summary-eyebrow">
                    {this.props.match.params.month}
                  </span>
                  <h4 className="consultancy-summary-title">
                    Order summary
                  </h4>
                </div>
                <div className="consultancy-summary-tiles">
                  <div className="consultancy-summary-tile">
                    <span className="consultancy-summary-label">
                      Total Rmb
                    </span>
                    <span className="consultancy-summary-value">
                      <CountUp className="counter" end={totalRmb} />
                      <span className="consultancy-summary-unit">Rmb</span>
                    </span>
                  </div>
                  <div className="consultancy-summary-tile">
                    <span className="consultancy-summary-label">
                      Total bill
                    </span>
                    <span className="consultancy-summary-value">
                      <CountUp className="counter" end={totalBill} />
                      <span className="consultancy-summary-unit">Tk</span>
                    </span>
                  </div>
                  <div className="consultancy-summary-tile">
                    <span className="consultancy-summary-label">
                      Total paid
                    </span>
                    <span className="consultancy-summary-value">
                      <CountUp className="counter" end={totalPaid} />
                      <span className="consultancy-summary-unit">Tk</span>
                    </span>
                  </div>
                  <div className="consultancy-summary-tile">
                    <span className="consultancy-summary-label">
                      Buying cost
                    </span>
                    <span className="consultancy-summary-value">
                      <CountUp className="counter" end={buyingCost} />
                      <span className="consultancy-summary-unit">Tk</span>
                    </span>
                  </div>
                  <div className="consultancy-summary-tile consultancy-summary-tile--accent">
                    <span className="consultancy-summary-label">
                      Total profit
                    </span>
                    <span className="consultancy-summary-value">
                      <CountUp className="counter" end={totalProfit} />
                      <span className="consultancy-summary-unit">Tk</span>
                    </span>
                  </div>
                  <div className="consultancy-summary-tile consultancy-summary-tile--refund">
                    <span className="consultancy-summary-label">
                      Refund given
                    </span>
                    <span className="consultancy-summary-value">
                      <CountUp
                        className="counter"
                        end={summaryRefundGiven}
                        decimals={2}
                      />
                      <span className="consultancy-summary-unit">Tk</span>
                    </span>
                  </div>
                  <div className="consultancy-summary-tile consultancy-summary-tile--refund-taken">
                    <span className="consultancy-summary-label">
                      Refund taken
                    </span>
                    <span className="consultancy-summary-value">
                      <CountUp
                        className="counter"
                        end={summaryRefundTaken}
                        decimals={2}
                      />
                      <span className="consultancy-summary-unit">Tk</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-12">
              <div className="card">
                <div
                  className="card-header"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    borderBottom: "1px solid gainsboro",
                  }}
                >
                  <h5>
                    <i
                      className="icofont-money"
                      style={{
                        fontSize: "130%",
                        marginRight: "5px",
                        color: "#00254c",
                      }}
                    ></i>
                    {this.props.match.params.month}
                  </h5>
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    <div>
                      <select
                        title="Filter by country"
                        required
                        name="filterCountry"
                        className="custom-select"
                        aria-required="true"
                        aria-invalid="false"
                        onChange={this.handleChange}
                        value={this.state.filterCountry}
                      >
                        <option value="">Filter by country </option>
                        <option value="">All</option>
                        <option value="INDIA">INDIA</option>
                        <option value="CHINA">CHINA</option>
                      </select>
                    </div>
                    <button
                      style={{ marginLeft: 10 }}
                      className="btn btn-primary"
                      data-toggle="modal"
                      data-target="#personalInfoModal"
                      onClick={() => {
                        this.setState({
                          totalBill: "",
                          agent: "",
                          totalRmb: "",
                          sellRate: "",
                          buyRate: "",
                          productLink: "",
                          productName: "",
                          productsArray: [],
                          productDetails: "",
                          totalPaid: 0,
                          sourcingObj: null,
                          type: "upload",
                          buyingCost: 0,
                          finalProfit: 0,
                          customer: "",
                          customerUid: "",
                          cursor: -1,
                          agentPaid: 0,

                          algProfit: 0,
                        });
                      }}
                    >
                      New Invoice
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="clearfix"></div>
                  <div id="basicScenario" className="product-physical">
                    <div className="table-responsive consultancy-invoice-table-wrap">
                    <table className="table table-bordered table-striped table-hover consultancy-invoice-table consultancy-invoice-table--invoice">
                      <thead>
                        <tr>
                          <th scope="col">#</th>
                          <th scope="col">Date</th>
                          <th scope="col">Id</th>
                          <th scope="col">Agent</th>
                          <th scope="col">Customer</th>
                          <th scope="col">Product Name</th>
                          <th scope="col">Country</th>
                          <th scope="col" className="text-center">Action</th>
                          <th scope="col" className="text-center">Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {renderablesourcings.map((sourcing, index) => (
                          <Fragment key={index}>
                            <tr className="consultancy-invoice-row">
                              <th
                                scope="row"
                                onClick={() => {
                                  this.props.history.push(
                                    `/business-consultancy/sourcing/${sourcing.id}`,
                                  );
                                }}
                              >
                                {index + 1}
                              </th>
                              <td
                                onClick={() => {
                                  this.props.history.push(
                                    `/business-consultancy/sourcing/${sourcing.id}`,
                                  );
                                }}
                              >
                                {sourcing.date}
                              </td>
                              <td
                                onClick={() => {
                                  this.props.history.push(
                                    `/business-consultancy/sourcing/${sourcing.id}`,
                                  );
                                }}
                              >
                                {sourcing.id}
                              </td>
                              <td
                                onClick={() => {
                                  this.props.history.push(
                                    `/business-consultancy/sourcing/${sourcing.id}`,
                                  );
                                }}
                              >
                                {sourcing.agent}
                              </td>
                              <td
                                style={{
                                  maxWidth: 160,
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                                title={sourcing.customer}
                              >
                                {sourcing.customer}
                              </td>
                              <td
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  this.props.history.push(
                                    `/business-consultancy/sourcing/${sourcing.id}`,
                                  );
                                }}
                              >
                                {sourcing.productsArray &&
                                sourcing.productsArray.length > 0 ? (
                                  <div className="consultancy-packing-summary">
                                    <img
                                      className="consultancy-packing-thumb"
                                      src={
                                        sourcing.productsArray[0].imageUrl ||
                                        man
                                      }
                                      alt=""
                                    />
                                    <span className="consultancy-packing-name">
                                      {sourcing.productsArray[0]
                                        .productName || "Unnamed product"}
                                    </span>
                                    {sourcing.productsArray.length > 1 && (
                                      <span className="consultancy-packing-more">
                                        +{sourcing.productsArray.length - 1}{" "}
                                        more
                                      </span>
                                    )}
                                  </div>
                                ) : sourcing.productName ? (
                                  sourcing.productName
                                ) : (
                                  <span className="consultancy-packing-more">
                                    + Add products
                                  </span>
                                )}
                              </td>
                              <td
                                onClick={() => {
                                  this.props.history.push(
                                    `/business-consultancy/sourcing/${sourcing.id}`,
                                  );
                                }}
                              >
                                {sourcing.country}
                              </td>
                              {sourcing.status === "pending" ? (
                                <td className="text-center">
                                  <div
                                    className="row"
                                    style={{ justifyContent: "center" }}
                                  >
                                    <i
                                      className="icofont-edit"
                                      data-toggle="modal"
                                      data-target="#personalInfoModal"
                                      onClick={() => {
                                        this.setState({
                                          sourcingObj: sourcing,
                                          totalBill: sourcing.totalBill,
                                          totalPaid: 0,
                                          agent: sourcing.agent,
                                          productLink: sourcing.productLink,
                                          productName: sourcing.productName,
                                          productsArray:
                                            sourcing.productsArray &&
                                            sourcing.productsArray.length > 0
                                              ? sourcing.productsArray
                                              : [],
                                          productDetails:
                                            sourcing.productDetails,
                                          buyingCost: 0,
                                          sellRate: sourcing.sellRate || 0,
                                          buyRate: sourcing.buyRate,
                                          totalRmb: sourcing.totalRmb || 0,
                                          status: "pending",
                                          type: "update",
                                          customer: sourcing.customer,
                                          customerUid: sourcing.customerUid,
                                          cursor: -1,
                                          sourcingStatus:
                                            sourcing.sourcingStatus,
                                          country: sourcing.country,
                                          agentPaid: sourcing.agentPaid,
                                          finalProfit: sourcing.finalProfit,
                                          algProfit: sourcing.algProfit,
                                        });
                                      }}
                                      style={{
                                        color: "green",
                                        marginRight: 8,
                                        cursor: "pointer",
                                      }}
                                    />{" "}
                                    <i
                                      className="icofont-trash"
                                      data-toggle="modal"
                                      data-target="#deleteExpenseModal"
                                      onClick={() => {
                                        this.setState({
                                          sourcingObj: sourcing,
                                        });
                                      }}
                                      style={{
                                        color: "red",
                                        marginLeft: 8,
                                        cursor: "pointer",
                                      }}
                                    />
                                  </div>
                                </td>
                              ) : (
                                <td></td>
                              )}
                              <td className="text-center">
                                <span
                                  className="consultancy-status-badge"
                                  title={sourcing.sourcingStatus || "Pending"}
                                  style={{
                                    background: getSourcingStatusGradient(
                                      sourcing.sourcingStatus,
                                    ),
                                  }}
                                  data-toggle="modal"
                                  data-target="#StatusModal"
                                  onClick={async () => {
                                    this.setState({
                                      sourcingObj: sourcing,
                                      sourcingStatus: sourcing.sourcingStatus
                                        ? sourcing.sourcingStatus
                                        : "",
                                      trackingNo: sourcing.trackingNo
                                        ? sourcing.trackingNo
                                        : "",
                                    });
                                  }}
                                >
                                  {sourcing.sourcingStatus || "Update"}
                                </span>
                              </td>
                            </tr>
                            <tr className="consultancy-invoice-detail-row">
                              <td colSpan={9}>
                                <div className="consultancy-invoice-detail-layout">
                                  <div className="consultancy-invoice-stat-grid">
                                    <div className="consultancy-invoice-stat">
                                      <span className="consultancy-invoice-stat-label">
                                        Total
                                      </span>
                                      <span className="consultancy-invoice-stat-value">
                                        {sourcing.totalRmb || 0}
                                        {sourcing.country == "INDIA"
                                          ? " rupees"
                                          : " rmb"}
                                      </span>
                                    </div>
                                    <div className="consultancy-invoice-stat">
                                      <span className="consultancy-invoice-stat-label">
                                        Sell Rate
                                      </span>
                                      <span className="consultancy-invoice-stat-value">
                                        {sourcing.sellRate || 0}Tk
                                      </span>
                                    </div>
                                    <div className="consultancy-invoice-stat">
                                      <span className="consultancy-invoice-stat-label">
                                        Buy Rate
                                      </span>
                                      <span className="consultancy-invoice-stat-value">
                                        {sourcing.buyRate || 0}Tk
                                      </span>
                                    </div>
                                    <div className="consultancy-invoice-stat">
                                      <span className="consultancy-invoice-stat-label">
                                        Total Bill
                                      </span>
                                      <span className="consultancy-invoice-stat-value">
                                        {sourcing.totalBill || 0}Tk
                                      </span>
                                    </div>
                                    <div className="consultancy-invoice-stat">
                                      <span className="consultancy-invoice-stat-label">
                                        Total Paid
                                      </span>
                                      <span className="consultancy-invoice-stat-value">
                                        {sourcing.totalPaid || 0}Tk
                                      </span>
                                    </div>
                                    <div className="consultancy-invoice-stat">
                                      <span className="consultancy-invoice-stat-label">
                                        Buying Cost
                                      </span>
                                      <span className="consultancy-invoice-stat-value">
                                        {sourcing.buyingCost || 0}Tk
                                      </span>
                                    </div>
                                    <div className="consultancy-invoice-stat consultancy-invoice-stat--profit">
                                      <span className="consultancy-invoice-stat-label">
                                        Total Profit
                                      </span>
                                      <span className="consultancy-invoice-stat-value">
                                        {sourcing.finalProfit || 0}Tk
                                      </span>
                                    </div>
                                    <div className="consultancy-invoice-stat consultancy-invoice-stat--profit">
                                      <span className="consultancy-invoice-stat-label">
                                        Agent Profit
                                      </span>
                                      <span className="consultancy-invoice-stat-value">
                                        {sourcing.agentPaid || 0}Tk
                                      </span>
                                    </div>
                                    <div className="consultancy-invoice-stat consultancy-invoice-stat--profit">
                                      <span className="consultancy-invoice-stat-label">
                                        Zapai Profit
                                      </span>
                                      <span className="consultancy-invoice-stat-value">
                                        {sourcing.algProfit || 0}Tk
                                      </span>
                                    </div>
                                    {(() => {
                                      const refundTotals =
                                        getRefundTotals(sourcing);
                                      return (
                                        <>
                                          {refundTotals.given > 0 && (
                                            <div className="consultancy-invoice-stat consultancy-invoice-stat--refund">
                                              <span className="consultancy-invoice-stat-label">
                                                Refund Given
                                              </span>
                                              <span className="consultancy-invoice-stat-value">
                                                {refundTotals.given.toFixed(
                                                  2,
                                                )}
                                                Tk
                                              </span>
                                            </div>
                                          )}
                                          {refundTotals.taken > 0 && (
                                            <div className="consultancy-invoice-stat consultancy-invoice-stat--refund-taken">
                                              <span className="consultancy-invoice-stat-label">
                                                Refund Taken
                                              </span>
                                              <span className="consultancy-invoice-stat-value">
                                                {refundTotals.taken.toFixed(
                                                  2,
                                                )}
                                                Tk
                                              </span>
                                            </div>
                                          )}
                                        </>
                                      );
                                    })()}
                                  </div>
                                  {currentAdmin &&
                                  currentAdmin.status !== "Employee" &&
                                  currentAdmin.status !== "Officer" ? (
                                    currentAdmin.status === "Admin" ||
                                    currentAdmin.status === "Accounts" ||
                                    (selectedEmployee &&
                                      selectedEmployee.rupeeBalance > 0) ||
                                    (selectedEmployee &&
                                      selectedEmployee.rmbBalance > 0) ? (
                                      <div className="consultancy-invoice-actions">
                                        <button
                                          type="button"
                                          className="consultancy-invoice-action-btn consultancy-invoice-action-btn--refund"
                                          data-toggle="modal"
                                          data-target="#StatusModal1"
                                          onClick={() => {
                                            this.setState({
                                              sourcingObj: sourcing,
                                            });
                                          }}
                                        >
                                          <i className="icofont-tick-boxed" />{" "}
                                          Refund
                                        </button>
                                        <button
                                          type="button"
                                          className="consultancy-invoice-action-btn consultancy-invoice-action-btn--cashin"
                                          data-toggle="modal"
                                          data-target="#InvoiceInfoModal1"
                                          onClick={() => {
                                            this.setState({
                                              sourcingObj: sourcing,
                                            });
                                          }}
                                        >
                                          <i className="icofont-tick-boxed" />{" "}
                                          Cash In
                                        </button>
                                        <button
                                          type="button"
                                          className="consultancy-invoice-action-btn consultancy-invoice-action-btn--cashout"
                                          data-toggle="modal"
                                          data-target="#InvoiceInfoModal2"
                                          onClick={() => {
                                            this.setState({
                                              sourcingObj: sourcing,
                                            });
                                          }}
                                        >
                                          <i className="icofont-tick-boxed" />{" "}
                                          Cash Out
                                        </button>
                                      </div>
                                    ) : null
                                  ) : null}
                                </div>
                              </td>
                            </tr>
                          </Fragment>
                        ))}
                      </tbody>
                    </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
        {/* <!-- Container-fluid Ends--> */}

        <div
          className="modal fade"
          id="personalInfoModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div
            className="modal-dialog"
            role="document"
            style={{ margin: "auto" }}
          >
            <div className="modal-content consultancy-modal" style={{ margin: "auto" }}>
              <div
                className="modal-header"
                style={{
                  backgroundColor: "rgb(0, 37, 76)",
                  paddingTop: 20,
                  paddingBottom: 20,
                }}
              >
                <div
                  className="modal-title"
                  style={{
                    fontWeight: "bold",
                    fontSize: 17,
                    color: "white",
                  }}
                  id="exampleModalLabel"
                >
                  Create order Invoice
                </div>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  id="personal-info-close"
                >
                  <span aria-hidden="true" style={{ color: "white" }}>
                    &times;
                  </span>
                </button>
              </div>

              <div className="modal-body">
                <div style={{ padding: "10px 15px" }}>
                  <div className="form-group">
                    <label
                      style={{
                        fontWeight: "bold",
                        color: "#505050",
                        marginBottom: 5,
                      }}
                    >
                      Order agent
                    </label>
                    <select
                      title="Please choose a package"
                      required
                      name="agent"
                      className="custom-select"
                      aria-required="true"
                      aria-invalid="false"
                      onChange={this.handleChange}
                      value={this.state.agent}
                    >
                      <option value="">Select employee</option>
                      {allEmployees.map((employee) => (
                        <option value={`${employee.name}`}>
                          {employee.name}-{employee.designation}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="form-group">
                    <label
                      style={{
                        fontWeight: "bold",
                        color: "#505050",
                        marginBottom: 5,
                      }}
                    >
                      Customer name
                    </label>
                    <input
                      style={{ padding: 18 }}
                      type="text"
                      name="customer"
                      className="form-control"
                      placeholder="Enter customer name"
                      aria-required="true"
                      aria-invalid="false"
                      onChange={this.handleChange}
                      value={this.state.customer}
                      required
                      autoComplete="off"
                    />
                  </div>
                  <div className="form-group">
                    <label
                      style={{
                        fontWeight: "bold",
                        color: "#505050",
                        marginBottom: 5,
                      }}
                    >
                      Select country
                    </label>
                    <select
                      title="Please choose a package"
                      required
                      name="country"
                      className="custom-select"
                      aria-required="true"
                      aria-invalid="false"
                      onChange={this.handleChange}
                      value={this.state.country}
                    >
                      <option value="">Select country</option>
                      <option value="INDIA">INDIA</option>
                      <option value="CHINA">CHINA</option>
                    </select>
                  </div>
                  {this.state.country && (
                    <>
                      <div className="form-group">
                        <label
                          style={{
                            fontWeight: "bold",
                            color: "#505050",
                            marginBottom: 5,
                          }}
                        >
                          Products
                        </label>
                        {this.state.productsArray.length > 0 ? (
                          <div
                            className="consultancy-packing-summary"
                            data-toggle="modal"
                            data-target="#packingListModal"
                          >
                            <img
                              className="consultancy-packing-thumb"
                              src={
                                this.state.productsArray[0].imageUrl || man
                              }
                              alt=""
                            />
                            <span className="consultancy-packing-name">
                              {this.state.productsArray[0].productName ||
                                "Unnamed product"}
                            </span>
                            {this.state.productsArray.length > 1 && (
                              <span className="consultancy-packing-more">
                                +{this.state.productsArray.length - 1} more
                                product
                                {this.state.productsArray.length - 1 === 1
                                  ? ""
                                  : "s"}
                              </span>
                            )}
                          </div>
                        ) : (
                          <button
                            type="button"
                            className="consultancy-packing-add-btn"
                            data-toggle="modal"
                            data-target="#packingListModal"
                          >
                            + Add products
                          </button>
                        )}
                      </div>

                      <div className="form-group">
                        <label
                          style={{
                            fontWeight: "bold",
                            color: "#505050",
                            marginBottom: 5,
                          }}
                        >
                          Total{" "}
                          {this.state.country == "INDIA" ? "Rupees" : "Rmb"}
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          name="totalRmb"
                          value={this.state.totalRmb}
                          onChange={this.handleChange}
                          id="exampleFormControlInput1"
                          placeholder={`Total ${
                            this.state.country == "INDIA" ? "RUPEES" : "RMB"
                          }`}
                          style={{
                            borderColor: "gainsboro",
                            borderRadius: 5,
                          }}
                        />
                      </div>
                      <div className="form-group">
                        <label
                          style={{
                            fontWeight: "bold",
                            color: "#505050",
                            marginBottom: 5,
                          }}
                        >
                          {this.state.country == "INDIA" ? "Rupees" : "Rmb"}{" "}
                          sell rate
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          name="sellRate"
                          value={this.state.sellRate}
                          onChange={this.handleChange}
                          id="exampleFormControlInput1"
                          placeholder="sell rate"
                          style={{
                            borderColor: "gainsboro",
                            borderRadius: 5,
                          }}
                        />
                      </div>
                      <div className="form-group">
                        <label
                          style={{
                            fontWeight: "bold",
                            color: "#505050",
                            marginBottom: 5,
                          }}
                        >
                          {this.state.country == "INDIA" ? "Rupees" : "Rmb"} buy
                          rate
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          name="buyRate"
                          value={this.state.buyRate}
                          onChange={this.handleChange}
                          id="exampleFormControlInput1"
                          placeholder="buy rate"
                          style={{
                            borderColor: "gainsboro",
                            borderRadius: 5,
                          }}
                        />
                      </div>
                    </>
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn "
                  data-dismiss="modal"
                  style={{
                    backgroundColor: "darkorange",
                    color: "white",
                    padding: 8,
                    borderRadius: 5,
                    fontWeight: "lighter",
                  }}
                  onClick={() => {
                    this.handleSubmit(sourcingObj);
                  }}
                >
                  Create Invoice
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="deleteExpenseModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div
            className="modal-dialog"
            role="document"
            style={{ margin: "auto" }}
          >
            <div className="modal-content responsive-modal consultancy-modal">
              <div
                className="modal-header"
                style={{
                  backgroundColor: "rgb(0, 37, 76)",
                  paddingTop: 20,
                  paddingBottom: 20,
                }}
              >
                <div
                  className="modal-title"
                  style={{
                    fontWeight: "bold",
                    fontSize: 17,
                    color: "white",
                  }}
                  id="exampleModalLabel"
                >
                  Delete order Invoice
                </div>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  id="personal-info-close"
                >
                  <span aria-hidden="true" style={{ color: "white" }}>
                    &times;
                  </span>
                </button>
              </div>
              <div className="modal-body">
                <div style={{ marginBottom: 18 }}>
                  Are you sure you want to delete this order? This can't be
                  undone.
                </div>
                <div className="consultancy-modal-summary">
                  <div className="consultancy-modal-summary-item">
                    <span className="consultancy-modal-summary-label">
                      Agent
                    </span>
                    <span className="consultancy-modal-summary-value">
                      {sourcingObj && sourcingObj.agent}
                    </span>
                  </div>
                  <div className="consultancy-modal-summary-item">
                    <span className="consultancy-modal-summary-label">
                      Customer
                    </span>
                    <span className="consultancy-modal-summary-value">
                      {sourcingObj && sourcingObj.customer}
                    </span>
                  </div>
                  <div className="consultancy-modal-summary-item">
                    <span className="consultancy-modal-summary-label">
                      Total
                    </span>
                    <span className="consultancy-modal-summary-value">
                      {(sourcingObj && sourcingObj.totalRmb) || 0}Rmb
                    </span>
                  </div>
                  <div className="consultancy-modal-summary-item">
                    <span className="consultancy-modal-summary-label">
                      Sell rate
                    </span>
                    <span className="consultancy-modal-summary-value">
                      {(sourcingObj && sourcingObj.sellRate) || 0}Tk/Rmb
                    </span>
                  </div>
                  <div className="consultancy-modal-summary-item">
                    <span className="consultancy-modal-summary-label">
                      Total bill
                    </span>
                    <span className="consultancy-modal-summary-value">
                      {sourcingObj && sourcingObj.totalBill}Tk
                    </span>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                >
                  No
                </button>
                <button
                  type="button"
                  className="btn "
                  data-dismiss="modal"
                  style={{
                    backgroundColor: "red",
                    color: "white",
                    padding: 8,
                    borderRadius: 5,
                  }}
                  onClick={() => {
                    this.props.deleteSourcingRedux(sourcingObj.id);
                  }}
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="InvoiceInfoModal1"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div
            className="modal-dialog"
            role="document"
            style={{ margin: "auto" }}
          >
            <div className="modal-content responsive-modal consultancy-modal">
              <div
                className="modal-header"
                style={{
                  backgroundColor: "rgb(0, 37, 76)",
                  paddingTop: 20,
                  paddingBottom: 20,
                }}
              >
                <div
                  className="modal-title"
                  style={{
                    fontWeight: "bold",
                    fontSize: 17,
                    color: "white",
                  }}
                  id="exampleModalLabel"
                >
                  Receive Cash
                </div>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  id="personal-info-close"
                >
                  <span aria-hidden="true" style={{ color: "white" }}>
                    &times;
                  </span>
                </button>
              </div>
              <div className="modal-body">
                <div className="consultancy-modal-summary">
                  <div className="consultancy-modal-summary-item">
                    <span className="consultancy-modal-summary-label">
                      Invoice Id
                    </span>
                    <span className="consultancy-modal-summary-value">
                      {sourcingObj && sourcingObj.id}
                    </span>
                  </div>
                  <div className="consultancy-modal-summary-item">
                    <span className="consultancy-modal-summary-label">
                      Agent
                    </span>
                    <span className="consultancy-modal-summary-value">
                      {sourcingObj && sourcingObj.agent}
                    </span>
                  </div>
                  <div className="consultancy-modal-summary-item">
                    <span className="consultancy-modal-summary-label">
                      Customer
                    </span>
                    <span className="consultancy-modal-summary-value">
                      {sourcingObj && sourcingObj.customer}
                    </span>
                  </div>
                  <div className="consultancy-modal-summary-item">
                    <span className="consultancy-modal-summary-label">
                      Total
                    </span>
                    <span className="consultancy-modal-summary-value">
                      {(sourcingObj && sourcingObj.totalRmb) || 0}{" "}
                      {sourcingObj && sourcingObj.country == "INDIA"
                        ? " Rupees"
                        : " Rmb"}
                    </span>
                  </div>
                  <div className="consultancy-modal-summary-item">
                    <span className="consultancy-modal-summary-label">
                      Sell rate
                    </span>
                    <span className="consultancy-modal-summary-value">
                      {(sourcingObj && sourcingObj.sellRate) || 0}Tk/{" "}
                      {sourcingObj && sourcingObj.country == "INDIA"
                        ? " Rupees"
                        : " Rmb"}
                    </span>
                  </div>
                  <div className="consultancy-modal-summary-item">
                    <span className="consultancy-modal-summary-label">
                      Total bill
                    </span>
                    <span className="consultancy-modal-summary-value">
                      {sourcingObj && sourcingObj.totalBill}Tk
                    </span>
                  </div>
                  <div className="consultancy-modal-summary-item">
                    <span className="consultancy-modal-summary-label">
                      Order due
                    </span>
                    <span className="consultancy-modal-summary-value">
                      {remainingBalance2.toFixed(2)} Tk
                    </span>
                  </div>
                </div>
                <div className="form-group">
                  <label
                    style={{
                      fontWeight: "bold",
                      color: "#505050",
                      marginBottom: 5,
                    }}
                  >
                    Received cash
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    name="totalPaid"
                    value={this.state.totalPaid}
                    onChange={this.handleChange}
                    id="exampleFormControlInput1"
                    placeholder="Enter amount"
                    style={{
                      borderColor: "gainsboro",
                      borderRadius: 5,
                    }}
                  />
                  <span style={{ marginTop: 5, color: "gray", fontSize: 14 }}>
                    ***Received cash amount must be less than or equal to order
                    due.
                  </span>
                </div>
                {sourcingObj &&
                  sourcingObj.cashIns &&
                  sourcingObj.cashIns.length > 0 && (
                    <div>
                      <label
                        style={{
                          fontWeight: "bold",
                          color: "#505050",
                          marginBottom: 5,
                        }}
                      >
                        Previous cash ins
                      </label>
                      <table className="table table-bordered table-striped table-hover">
                        <thead>
                          <tr style={{ background: "rgb(0, 37, 76)" }}>
                            <th style={{ color: "white" }}>Date</th>
                            <th style={{ color: "white" }}>Amount</th>
                            <th style={{ color: "white" }}>Entry By</th>
                          </tr>
                        </thead>
                        <tbody>
                          {sourcingObj.cashIns
                            .sort((a, b) => a.id - b.id)
                            .map((refund) => (
                              <tr>
                                <td>{refund.date}</td>
                                <td>{refund.amount} Tk</td>
                                <td>{refund.expenseBy}</td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  )}
              </div>
              <div className="modal-footer">
                {remainingBalance2 <= 0 ? (
                  <button
                    type="button"
                    className="btn "
                    data-dismiss="modal"
                    style={{
                      backgroundColor: "darkgreen",
                      color: "white",
                      padding: 8,
                      borderRadius: 5,
                    }}
                  >
                    Paid
                  </button>
                ) : (
                  <button
                    type="button"
                    className="btn "
                    data-dismiss="modal"
                    style={{
                      backgroundColor: "darkgreen",
                      color: "white",
                      padding: 8,
                      borderRadius: 5,
                    }}
                    onClick={() => {
                      this.handleCashIn(sourcingObj);
                    }}
                  >
                    Cash In
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="StatusModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div
            className="modal-dialog"
            role="document"
            style={{ margin: "auto" }}
          >
            <div className="modal-content responsive-modal consultancy-modal">
              <div className="modal-header">
                <div className="modal-title" id="exampleModalLabel">
                  Order details
                </div>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  id="personal-info-close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="consultancy-modal-summary">
                  <div className="consultancy-modal-summary-item">
                    <span className="consultancy-modal-summary-label">
                      Invoice Id
                    </span>
                    <span className="consultancy-modal-summary-value">
                      {sourcingObj && sourcingObj.id}
                    </span>
                  </div>
                  <div className="consultancy-modal-summary-item">
                    <span className="consultancy-modal-summary-label">
                      Status
                    </span>
                    <span className="consultancy-modal-summary-value">
                      <span
                        style={{
                          padding: "3px 10px",
                          background: getSourcingStatusGradient(
                            sourcingObj && sourcingObj.sourcingStatus,
                          ),
                          color: "white",
                          borderRadius: "5px",
                          fontSize: 12,
                          display: "inline-block",
                        }}
                      >
                        {(sourcingObj && sourcingObj.sourcingStatus) ||
                          "Pending"}
                      </span>
                    </span>
                  </div>
                  <div className="consultancy-modal-summary-item">
                    <span className="consultancy-modal-summary-label">
                      Order date
                    </span>
                    <span className="consultancy-modal-summary-value">
                      {(sourcingObj && sourcingObj.sourcingDate) || "-"}
                    </span>
                  </div>
                  <div className="consultancy-modal-summary-item">
                    <span className="consultancy-modal-summary-label">
                      Purchased date
                    </span>
                    <span className="consultancy-modal-summary-value">
                      {(sourcingObj && sourcingObj.purchasedDate) || "-"}
                    </span>
                  </div>
                </div>

                <div className="form-group" style={{ marginBottom: 0 }}>
                  <label
                    style={{
                      fontWeight: "bold",
                      color: "#505050",
                      marginBottom: 5,
                    }}
                  >
                    Update status
                  </label>
                  <select
                    title="Please choose a package"
                    required
                    name="sourcingStatus"
                    className="custom-select"
                    aria-required="true"
                    aria-invalid="false"
                    onChange={this.handleChange}
                    value={this.state.sourcingStatus}
                  >
                    <option value="">Select status</option>
                    <option value="Purchasing">Purchasing</option>
                    <option value="Purchased">Purchased</option>
                    <option value="Abroad Warehouse">Abroad Warehouse</option>
                    <option value="In Shipment">In Shipment</option>
                    <option value="Bangladesh Warehouse">
                      Bangladesh Warehouse
                    </option>
                    <option value="Delivered">Delivered</option>
                  </select>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn "
                  data-dismiss="modal"
                  style={{
                    backgroundColor: "darkgreen",
                    color: "white",
                    padding: 8,
                    borderRadius: 5,
                  }}
                  onClick={() => {
                    this.handleStatusChange(sourcingObj);
                  }}
                >
                  Update Status
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="StatusModal1"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div
            className="modal-dialog"
            role="document"
            style={{ margin: "auto" }}
          >
            <div className="modal-content responsive-modal consultancy-modal">
              <div
                className="modal-header"
                style={{
                  backgroundColor: "rgb(0, 37, 76)",
                  paddingTop: 20,
                  paddingBottom: 20,
                }}
              >
                <div
                  className="modal-title"
                  style={{
                    fontWeight: "bold",
                    fontSize: 17,
                    color: "white",
                  }}
                  id="exampleModalLabel"
                >
                  Order summary
                </div>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  id="personal-info-close"
                >
                  <span aria-hidden="true" style={{ color: "white" }}>
                    &times;
                  </span>
                </button>
              </div>
              <div className="modal-body">
                <div className="consultancy-modal-summary">
                  <div className="consultancy-modal-summary-item">
                    <span className="consultancy-modal-summary-label">
                      Invoice Id
                    </span>
                    <span className="consultancy-modal-summary-value">
                      {sourcingObj && sourcingObj.id}
                    </span>
                  </div>
                  <div className="consultancy-modal-summary-item">
                    <span className="consultancy-modal-summary-label">
                      Total{" "}
                      {sourcingObj && sourcingObj.country == "INDIA"
                        ? "rupees"
                        : "rmb"}
                    </span>
                    <span className="consultancy-modal-summary-value">
                      {sourcingObj && sourcingObj.totalRmb}
                    </span>
                  </div>
                  <div className="consultancy-modal-summary-item">
                    <span className="consultancy-modal-summary-label">
                      Buy rate
                    </span>
                    <span className="consultancy-modal-summary-value">
                      {sourcingObj && sourcingObj.buyRate} Tk
                    </span>
                  </div>
                  <div className="consultancy-modal-summary-item">
                    <span className="consultancy-modal-summary-label">
                      Sell rate
                    </span>
                    <span className="consultancy-modal-summary-value">
                      {sourcingObj && sourcingObj.sellRate} Tk
                    </span>
                  </div>
                  <div className="consultancy-modal-summary-item">
                    <span className="consultancy-modal-summary-label">
                      Total bill
                    </span>
                    <span className="consultancy-modal-summary-value">
                      {sourcingObj && sourcingObj.totalBill} Tk
                    </span>
                  </div>
                  <div className="consultancy-modal-summary-item">
                    <span className="consultancy-modal-summary-label">
                      Total paid
                    </span>
                    <span className="consultancy-modal-summary-value">
                      {(sourcingObj && sourcingObj.totalPaid) || 0} Tk
                    </span>
                  </div>
                  <div className="consultancy-modal-summary-item">
                    <span className="consultancy-modal-summary-label">
                      Buying cost
                    </span>
                    <span className="consultancy-modal-summary-value">
                      {(sourcingObj && sourcingObj.buyingCost) || 0} Tk
                    </span>
                  </div>
                  <div className="consultancy-modal-summary-item">
                    <span className="consultancy-modal-summary-label">
                      Total refund given
                    </span>
                    <span className="consultancy-modal-summary-value">
                      {totalRefundGiven} Tk
                    </span>
                  </div>
                  <div className="consultancy-modal-summary-item">
                    <span className="consultancy-modal-summary-label">
                      Total refund received
                    </span>
                    <span className="consultancy-modal-summary-value">
                      {totalRefundReceived}{" "}
                      {sourcingObj && sourcingObj.country == "INDIA"
                        ? "rupees"
                        : "rmb"}{" "}
                      * {sourcingObj && sourcingObj.buyRate} ={" "}
                      {totalRefundReceivedTk} Tk
                    </span>
                  </div>
                  <div className="consultancy-modal-summary-item">
                    <span className="consultancy-modal-summary-label">
                      Total other charges
                    </span>
                    <span className="consultancy-modal-summary-value">
                      {totalOtherCharges}{" "}
                      {sourcingObj && sourcingObj.country == "INDIA"
                        ? "rupees"
                        : "rmb"}{" "}
                      * {sourcingObj && sourcingObj.buyRate} ={" "}
                      {totalOtherChargesTk} Tk
                    </span>
                  </div>
                  <div className="consultancy-modal-summary-item">
                    <span className="consultancy-modal-summary-label">
                      Total profit
                    </span>
                    <span className="consultancy-modal-summary-value">
                      {sourcingObj &&
                        sourcingObj.finalProfit +
                          totalRefundReceivedTk -
                          totalRefundGiven -
                          totalOtherChargesTk}{" "}
                      Tk
                    </span>
                  </div>
                  <div className="consultancy-modal-summary-item">
                    <span className="consultancy-modal-summary-label">
                      Agent profit
                    </span>
                    <span className="consultancy-modal-summary-value">
                      {sourcingObj && sourcingObj.agentPaid} Tk
                    </span>
                  </div>
                  <div className="consultancy-modal-summary-item consultancy-modal-summary-item--accent">
                    <span className="consultancy-modal-summary-label">
                      Zapai profit
                    </span>
                    <span className="consultancy-modal-summary-value">
                      {sourcingObj &&
                        sourcingObj.finalProfit +
                          totalRefundReceivedTk -
                          totalRefundGiven -
                          totalOtherChargesTk -
                          sourcingObj.agentPaid}{" "}
                      Tk
                    </span>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <div className="form-group">
                      <label
                        style={{
                          fontWeight: "bold",
                          color: "#505050",
                          marginBottom: 5,
                        }}
                      >
                        Refund type
                      </label>
                      <select
                        title="Please choose a package"
                        required
                        name="refundType"
                        className="custom-select"
                        aria-required="true"
                        aria-invalid="false"
                        onChange={this.handleChange}
                        value={this.state.refundType}
                      >
                        <option value="">Select type</option>
                        <option value="RECEIVED">Received</option>
                        <option value="GIVEN">Given</option>
                      </select>
                    </div>
                  </div>
                </div>
                {this.state.refundType == "GIVEN" && (
                  <>
                    <div className="form-group">
                      <label
                        style={{
                          fontWeight: "bold",
                          color: "#505050",
                          marginBottom: 5,
                        }}
                      >
                        Refund Given to customer in Tk
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        name="tkRefund"
                        value={this.state.tkRefund}
                        onChange={this.handleChange}
                        id="exampleFormControlInput1"
                        placeholder="Enter the amount in tk"
                        style={{
                          borderColor: "gainsboro",
                          borderRadius: 5,
                        }}
                      />
                    </div>
                    <div className="form-group">
                      <label
                        style={{
                          fontWeight: "bold",
                          color: "#505050",
                          marginBottom: 5,
                        }}
                      >
                        Taka Refund Note
                      </label>
                      <textarea
                        type="text"
                        className="form-control"
                        name="tkRefundNote"
                        value={this.state.tkRefundNote}
                        onChange={this.handleChange}
                        id="exampleFormControlInput1"
                        placeholder="Enter short note about why the refund is given to customer."
                        style={{
                          borderColor: "gainsboro",
                          borderRadius: 5,
                        }}
                      />
                    </div>
                  </>
                )}
                {this.state.refundType == "RECEIVED" && (
                  <>
                    <div className="form-group">
                      <label
                        style={{
                          fontWeight: "bold",
                          color: "#505050",
                          marginBottom: 5,
                        }}
                      >
                        {sourcingObj && sourcingObj.country === "INDIA"
                          ? "Rupees"
                          : "Rmb"}{" "}
                        Refund received
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        name="rmbRefund"
                        value={this.state.rmbRefund}
                        onChange={this.handleChange}
                        id="exampleFormControlInput1"
                        placeholder="Enter the amount in rupees/rmb"
                        style={{
                          borderColor: "gainsboro",
                          borderRadius: 5,
                        }}
                      />
                    </div>
                    <div className="form-group">
                      <label
                        style={{
                          fontWeight: "bold",
                          color: "#505050",
                          marginBottom: 5,
                        }}
                      >
                        {sourcingObj && sourcingObj.country === "INDIA"
                          ? "Rupees"
                          : "Rmb"}{" "}
                        Refund Note
                      </label>
                      <textarea
                        type="text"
                        className="form-control"
                        name="rmbRefundNote"
                        value={this.state.rmbRefundNote}
                        onChange={this.handleChange}
                        id="exampleFormControlInput1"
                        placeholder="Enter short note about why the refund is given to us by the supplier."
                        style={{
                          borderColor: "gainsboro",
                          borderRadius: 5,
                        }}
                      />
                    </div>
                  </>
                )}

                {sourcingObj &&
                  sourcingObj.givenRefund &&
                  sourcingObj.givenRefund.length > 0 && (
                    <div>
                      <label
                        style={{
                          fontWeight: "bold",
                          color: "#505050",
                          marginBottom: 5,
                        }}
                      >
                        Previous refund given
                      </label>
                      <table className="table table-bordered table-striped table-hover">
                        <thead>
                          <tr style={{ background: "rgb(0, 37, 76)" }}>
                            <th style={{ color: "white" }}>Date</th>

                            <th colSpan={3} style={{ color: "white" }}>
                              Note
                            </th>
                            <th style={{ color: "white" }}>Amount</th>
                            <th style={{ color: "white" }}>Entry By</th>
                          </tr>
                        </thead>
                        <tbody>
                          {sourcingObj.givenRefund
                            .sort((a, b) => a.id - b.id)
                            .map((refund) => (
                              <tr>
                                <td>{refund.date}</td>
                                <td colSpan={3}>{refund.note}</td>
                                <td>{refund.amount} Tk</td>
                                <td>{refund.expenseBy}</td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                {sourcingObj &&
                  sourcingObj.receivedRefund &&
                  sourcingObj.receivedRefund.length > 0 && (
                    <div>
                      <label
                        style={{
                          fontWeight: "bold",
                          color: "#505050",
                          marginBottom: 5,
                        }}
                      >
                        Previous refund received
                      </label>
                      <table className="table table-bordered table-striped table-hover">
                        <thead>
                          <tr style={{ background: "rgb(0, 37, 76)" }}>
                            <th style={{ color: "white" }}>Date</th>

                            <th colSpan={3} style={{ color: "white" }}>
                              Note
                            </th>
                            <th style={{ color: "white" }}>Amount</th>
                            <th style={{ color: "white" }}>Entry By</th>
                          </tr>
                        </thead>
                        <tbody>
                          {sourcingObj.receivedRefund
                            .sort((a, b) => a.id - b.id)
                            .map((refund) => (
                              <tr>
                                <td>{refund.date}</td>
                                <td colSpan={3}>{refund.note}</td>
                                <td>
                                  {refund.amount}{" "}
                                  {sourcingObj.country == "INDIA"
                                    ? "Rupees"
                                    : "Rmb"}
                                </td>
                                <td>{refund.expenseBy}</td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  )}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn "
                  data-dismiss="modal"
                  style={{
                    backgroundColor: "darkgreen",
                    color: "white",
                    padding: 8,
                    borderRadius: 5,
                  }}
                  onClick={() => {
                    this.handleRefund(totalRefundGiven);
                  }}
                >
                  Add New Refund
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="InvoiceInfoModal2"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div
            className="modal-dialog"
            role="document"
            style={{ margin: "auto" }}
          >
            <div className="modal-content responsive-modal consultancy-modal">
              <div
                className="modal-header"
                style={{
                  backgroundColor: "rgb(0, 37, 76)",
                  paddingTop: 20,
                  paddingBottom: 20,
                }}
              >
                <div
                  className="modal-title"
                  style={{
                    fontWeight: "bold",
                    fontSize: 17,
                    color: "white",
                  }}
                  id="exampleModalLabel"
                >
                  Spend Cash
                </div>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  id="personal-info-close"
                >
                  <span aria-hidden="true" style={{ color: "white" }}>
                    &times;
                  </span>
                </button>
              </div>
              <div className="modal-body">
                <div className="consultancy-modal-summary">
                  <div className="consultancy-modal-summary-item">
                    <span className="consultancy-modal-summary-label">
                      Rupee balance
                    </span>
                    <span className="consultancy-modal-summary-value">
                      {selectedEmployee && selectedEmployee.rupeeBalance
                        ? selectedEmployee.rupeeBalance
                        : 0}{" "}
                      Rupees
                    </span>
                  </div>
                  <div className="consultancy-modal-summary-item">
                    <span className="consultancy-modal-summary-label">
                      Rmb balance
                    </span>
                    <span className="consultancy-modal-summary-value">
                      {selectedEmployee && selectedEmployee.rmbBalance
                        ? selectedEmployee.rmbBalance
                        : 0}{" "}
                      Rmb
                    </span>
                  </div>
                  <div className="consultancy-modal-summary-item">
                    <span className="consultancy-modal-summary-label">
                      Remaining payment
                    </span>
                    <span className="consultancy-modal-summary-value">
                      {remainingBalance.toFixed(2)}{" "}
                      {sourcingObj && sourcingObj.country === "INDIA"
                        ? "Rupees"
                        : "Rmb"}
                    </span>
                  </div>
                  <div className="consultancy-modal-summary-item">
                    <span className="consultancy-modal-summary-label">
                      Invoice Id
                    </span>
                    <span className="consultancy-modal-summary-value">
                      {sourcingObj && sourcingObj.id}
                    </span>
                  </div>
                  <div className="consultancy-modal-summary-item">
                    <span className="consultancy-modal-summary-label">
                      Agent
                    </span>
                    <span className="consultancy-modal-summary-value">
                      {sourcingObj && sourcingObj.agent}
                    </span>
                  </div>
                  <div className="consultancy-modal-summary-item">
                    <span className="consultancy-modal-summary-label">
                      Customer
                    </span>
                    <span className="consultancy-modal-summary-value">
                      {sourcingObj && sourcingObj.customer}
                    </span>
                  </div>
                  <div className="consultancy-modal-summary-item">
                    <span className="consultancy-modal-summary-label">
                      Total
                    </span>
                    <span className="consultancy-modal-summary-value">
                      {sourcingObj && sourcingObj.totalRmb}{" "}
                      {sourcingObj && sourcingObj.country == "INDIA"
                        ? " Rupees"
                        : " Rmb"}
                    </span>
                  </div>
                  <div className="consultancy-modal-summary-item">
                    <span className="consultancy-modal-summary-label">
                      Buy rate
                    </span>
                    <span className="consultancy-modal-summary-value">
                      {sourcingObj && sourcingObj.buyRate}Tk/
                      {sourcingObj && sourcingObj.country == "INDIA"
                        ? " Rupees"
                        : " Rmb"}
                    </span>
                  </div>
                  <div className="consultancy-modal-summary-item">
                    <span className="consultancy-modal-summary-label">
                      Total
                    </span>
                    <span className="consultancy-modal-summary-value">
                      {sourcingObj &&
                        parseInt(
                          parseFloat(sourcingObj.totalRmb) *
                            parseFloat(sourcingObj.buyRate),
                        )}
                      Tk
                    </span>
                  </div>
                </div>
                <div className="form-group">
                  <label
                    style={{
                      fontWeight: "bold",
                      color: "#505050",
                      marginBottom: 5,
                    }}
                  >
                    Select cashout type
                  </label>
                  <select
                    title="Please choose a package"
                    required
                    name="cashOutType"
                    className="custom-select"
                    aria-required="true"
                    aria-invalid="false"
                    onChange={this.handleChange}
                    value={this.state.cashOutType}
                  >
                    <option value="">Select spend type</option>
                    <option value="Invoice Payment">Invoice Payment</option>
                    <option value="Other charges">Other charges</option>
                  </select>
                </div>
                {this.state.cashOutType == "Other charges" && (
                  <>
                    <div className="form-group">
                      <label
                        style={{
                          fontWeight: "bold",
                          color: "#505050",
                          marginBottom: 5,
                        }}
                      >
                        Other charge note{" "}
                      </label>
                      <textarea
                        type="text"
                        className="form-control"
                        name="otherChargeNote"
                        value={this.state.otherChargeNote}
                        onChange={this.handleChange}
                        id="exampleFormControlInput1"
                        placeholder="Write short note about why the charge is being added."
                        style={{
                          borderColor: "gainsboro",
                          borderRadius: 5,
                        }}
                      />
                    </div>

                    <div className="form-group">
                      <label
                        style={{
                          fontWeight: "bold",
                          color: "#505050",
                          marginBottom: 5,
                        }}
                      >
                        Spend{" "}
                        {sourcingObj && sourcingObj.country == "INDIA"
                          ? " Rupees"
                          : " Rmb"}
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        name="otherCharge"
                        value={this.state.otherCharge}
                        onChange={this.handleChange}
                        id="exampleFormControlInput1"
                        placeholder="Enter amount"
                        style={{
                          borderColor: "gainsboro",
                          borderRadius: 5,
                        }}
                      />
                      <span
                        style={{ marginTop: 5, color: "gray", fontSize: 14 }}
                      >
                        ***Your spend amount must be less than or equal to your{" "}
                        {sourcingObj && sourcingObj.country == "INDIA"
                          ? " RUPEES"
                          : " RMB"}{" "}
                        balance and remaining payment.
                      </span>
                    </div>
                  </>
                )}
                {this.state.cashOutType === "Invoice Payment" && (
                  <div className="form-group">
                    <label
                      style={{
                        fontWeight: "bold",
                        color: "#505050",
                        marginBottom: 5,
                      }}
                    >
                      Spend{" "}
                      {sourcingObj && sourcingObj.country == "INDIA"
                        ? " Rupees"
                        : " Rmb"}
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      name="buyingCost"
                      value={this.state.buyingCost}
                      onChange={this.handleChange}
                      id="exampleFormControlInput1"
                      placeholder="Enter amount"
                      style={{
                        borderColor: "gainsboro",
                        borderRadius: 5,
                      }}
                    />
                    <span style={{ marginTop: 5, color: "gray", fontSize: 14 }}>
                      ***Your spend amount must be less than or equal to your{" "}
                      {sourcingObj && sourcingObj.country == "INDIA"
                        ? " RUPEES"
                        : " RMB"}{" "}
                      balance and remaining payment.
                    </span>
                  </div>
                )}
                {sourcingObj &&
                  sourcingObj.cashOuts &&
                  sourcingObj.cashOuts.length > 0 && (
                    <div>
                      <label
                        style={{
                          fontWeight: "bold",
                          color: "#505050",
                          marginBottom: 5,
                        }}
                      >
                        Previous cash outs
                      </label>
                      <table className="table table-bordered table-striped table-hover">
                        <thead>
                          <tr style={{ background: "rgb(0, 37, 76)" }}>
                            <th style={{ color: "white" }}>Date</th>
                            <th style={{ color: "white" }}>Amount</th>
                            <th style={{ color: "white" }}>
                              {sourcingObj && sourcingObj.country === "INDIA"
                                ? "Rupees"
                                : "RMB"}
                            </th>
                            <th style={{ color: "white" }}>Entry By</th>
                          </tr>
                        </thead>
                        <tbody>
                          {sourcingObj.cashOuts
                            .sort((a, b) => a.id - b.id)
                            .map((refund) => (
                              <tr>
                                <td>{refund.date}</td>
                                <td>{refund.amount} Tk</td>
                                <td>
                                  {refund.rmb}{" "}
                                  {sourcingObj &&
                                  sourcingObj.country === "INDIA"
                                    ? "Rupees"
                                    : "RMB"}
                                </td>
                                <td>{refund.expenseBy}</td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                {sourcingObj &&
                  sourcingObj.otherCharges &&
                  sourcingObj.otherCharges.length > 0 && (
                    <div>
                      <label
                        style={{
                          fontWeight: "bold",
                          color: "#505050",
                          marginBottom: 5,
                        }}
                      >
                        Previous other charges
                      </label>
                      <table className="table table-bordered table-striped table-hover">
                        <thead>
                          <tr style={{ background: "rgb(0, 37, 76)" }}>
                            <th style={{ color: "white" }}>Date</th>
                            <th colSpan={3} style={{ color: "white" }}>
                              Note
                            </th>
                            <th style={{ color: "white" }}>Amount</th>
                            <th style={{ color: "white" }}>
                              {sourcingObj && sourcingObj.country === "INDIA"
                                ? "Rupees"
                                : "RMB"}
                            </th>
                            <th style={{ color: "white" }}>Entry By</th>
                          </tr>
                        </thead>
                        <tbody>
                          {sourcingObj.otherCharges
                            .sort((a, b) => a.id - b.id)
                            .map((refund) => (
                              <tr>
                                <td>{refund.date}</td>
                                <td colSpan={3}>{refund.note}</td>
                                <td>{refund.amount} Tk</td>
                                <td>
                                  {refund.rmb}{" "}
                                  {sourcingObj &&
                                  sourcingObj.country === "INDIA"
                                    ? "Rupees"
                                    : "RMB"}
                                </td>
                                <td>{refund.expenseBy}</td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  )}
              </div>
              <div className="modal-footer">
                {remainingBalance <= 0 &&
                this.state.cashOutType == "Invoice Payment" ? (
                  <button
                    type="button"
                    className="btn "
                    data-dismiss="modal"
                    style={{
                      backgroundColor: "darkgreen",
                      color: "white",
                      padding: 8,
                      borderRadius: 5,
                    }}
                  >
                    Paid
                  </button>
                ) : (
                  <button
                    type="button"
                    className="btn "
                    data-dismiss="modal"
                    style={{
                      backgroundColor: "red",
                      color: "white",
                      padding: 8,
                      borderRadius: 5,
                    }}
                    onClick={() => {
                      if (this.state.cashOutType == "Other charges") {
                        this.handleCashOutOtherCharge(sourcingObj);
                      } else if (this.state.cashOutType == "Invoice Payment") {
                        this.handleCashOut(sourcingObj);
                      } else {
                        alert("You must select a cashout type.");
                      }
                    }}
                  >
                    Cash Out
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade"
          id="packingListModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="packingListModalLabel"
          aria-hidden="true"
        >
          <div
            className="modal-dialog modal-lg"
            role="document"
            style={{ margin: "auto" }}
          >
            <div
              className="modal-content consultancy-modal"
              style={{ margin: "auto" }}
            >
              <div className="modal-header">
                <div className="modal-title" id="packingListModalLabel">
                  Products
                </div>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                {this.state.productsArray.length === 0 && (
                  <div className="consultancy-packing-empty">
                    No products added yet.
                  </div>
                )}
                {this.state.productsArray.map((product, index) => (
                  <div className="consultancy-packing-row" key={product.id}>
                    <div className="consultancy-packing-row-image">
                      <img
                        src={product.imageUrl || man}
                        alt=""
                        onClick={() => {
                          document
                            .getElementById(
                              `packing-image-input-invoice-${index}`,
                            )
                            .click();
                        }}
                      />
                      <input
                        id={`packing-image-input-invoice-${index}`}
                        type="file"
                        accept="image/*"
                        style={{ display: "none" }}
                        onChange={(e) => {
                          this.handleProductImageChange(
                            product.id,
                            e.target.files[0],
                          );
                        }}
                      />
                    </div>
                    <input
                      type="text"
                      className="form-control consultancy-packing-input"
                      placeholder="Product name"
                      value={product.productName}
                      onChange={(e) =>
                        this.updateProductRow(
                          product.id,
                          "productName",
                          e.target.value,
                        )
                      }
                    />
                    <input
                      type="number"
                      className="form-control consultancy-packing-input consultancy-packing-input--num"
                      placeholder="Price (Rmb)"
                      value={product.priceRmb}
                      onChange={(e) =>
                        this.updateProductRow(
                          product.id,
                          "priceRmb",
                          e.target.value,
                        )
                      }
                    />
                    <input
                      type="number"
                      className="form-control consultancy-packing-input consultancy-packing-input--num"
                      placeholder="Qty"
                      value={product.quantity}
                      onChange={(e) =>
                        this.updateProductRow(
                          product.id,
                          "quantity",
                          e.target.value,
                        )
                      }
                    />
                    <div className="consultancy-packing-row-total">
                      {(
                        (parseFloat(product.priceRmb) || 0) *
                        (parseFloat(product.quantity) || 0)
                      ).toFixed(2)}{" "}
                      Rmb
                    </div>
                    <i
                      className="icofont-trash consultancy-packing-row-remove"
                      onClick={() => this.removeProductRow(product.id)}
                    />
                  </div>
                ))}
                <button
                  type="button"
                  className="consultancy-packing-add-row-btn"
                  onClick={this.addProductRow}
                >
                  + Add product
                </button>

                <hr className="consultancy-modal-divider" />

                <div className="consultancy-packing-footer">
                  <div className="form-group consultancy-packing-shipping">
                    <label
                      style={{
                        fontWeight: "bold",
                        color: "#505050",
                        marginBottom: 5,
                      }}
                    >
                      Shipping charge (all products)
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      name="shipping"
                      placeholder="Enter shipping charge"
                      value={this.state.shipping}
                      onChange={this.handleChange}
                      style={{
                        borderColor: "gainsboro",
                        borderRadius: 5,
                      }}
                    />
                  </div>
                  <div className="consultancy-packing-grand-total">
                    <span className="consultancy-packing-grand-total-label">
                      Products total
                    </span>
                    <span className="consultancy-packing-grand-total-value">
                      {this.getProductsGrandTotal().toFixed(2)} Rmb
                    </span>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Done
                </button>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    allUsers: state.users.users,
    currentAdmin: state.admins.currentAdmin,
    sourcings: state.sourcings.sourcings,
    allEmployees: state.employees.employees.filter(
      (employee) => employee.status == "Active",
    ),
  };
};

export default connect(mapStateToProps, {
  getAllSourcingsRedux,
  uploadSourcingRedux,
  updateSourcingRedux,
  deleteSourcingRedux,
  getAllEmployeeRedux,
  updateEmployeeRedux,
  uploadSourcingTransactionRedux,
  handleSourcingCashInRedux,
  handleSourcingCashOutRedux,
  uploadExpenseRedux,
})(MonthlyInvoices);
